<template>
  <div class="container">
    <div class="content" v-if="!isMobile">
      <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="true" :close-image="closeBtnImg" :error-msg="errorMsg" @close="closeDialog" />
      <sys-loading :loading="loading" />
      <img class="logo" alt src="../assets/jump/logo.png" />
      <div class="form-content">
        <img class="title" alt src="../assets/jump/title.png" />
        <div class="form">
          <div class="tags">
            <span :class="isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = true">ĐĂNG KÝ</span>
            <span :class="!isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = false">ĐĂNG NHẬP</span>
          </div>
          <div class="inputs">
            <div class="form-input">
              <img src="../assets/jump/icon-username.png" />
              <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
            </div>
            <div class="form-input" v-show="isRegisterAction">
              <img src="../assets/jump/icon-phone.png" />
              <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
            </div>
            <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
              <img src="../assets/jump/icon-password.png" />
              <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
            </div>
            <div class="form-input" v-show="isRegisterAction">
              <img src="../assets/jump/icon-email.png" />
              <input v-model="form.email" autocomplete="off" placeholder="Email" />
            </div>
            <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;">
              <input v-model="form.verificationCode" style="text-indent: 10px;" autocomplete="off" maxlength="4" />
              <div class="codeImg">
                <span @click="getVerify" v-if="codeImg" class="validateCode">
                  <img class="img" :src="codeImg" alt="code" />
                </span>
              </div>
            </div>
            <a v-if="!isRegisterAction" class="error" href="https://www.8day.com">Quên Mật Khẩu?</a>
            <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" :vstyle="{
                width: '250px',
                height: '70px',
                top: '30px'
              }" :nativeButton="{
                width: '100%',
                height: '100%'
              }" @cb="handleConfirm">
              <div v-show="isRegisterAction" class="submitBtn" @click="submitAction(1)">
                ĐĂNG KÝ
              </div>
            </v-captcha>
            <div v-show="!isRegisterAction" class="submitBtn" @click="submitAction(2)">
              ĐĂNG NHẬP
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-content">
        <swiper :options="swiperOptions">
          <swiper-slide>
            <a href="https://8day.com" target="_blank">
              <img src="../assets/jump/swiper-1.png" alt="" width="100%" />
            </a>
          </swiper-slide>
        </swiper>
        <div class="prev-btn nav-btn" slot="button-prev"></div>
        <div class="next-btn nav-btn" slot="button-next"></div>
      </div>
    </div>
    <div class="root" v-if="isMobile">
      <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="true" :close-image="closeBtnImg" :error-msg="errorMsg" @close="closeDialog" />
      <sys-loading :loading="loading" />
      <img class="logo" alt src="../assets/jump/logo.png" />
      <img class="title" alt src="../assets/jump/title.png" />
      <div class="form-content">
        <div class="tags">
          <span :class="isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = true">ĐĂNG KÝ</span>
          <span :class="!isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = false">ĐĂNG NHẬP</span>
        </div>
        <div class="inputs" :style="isRegisterAction ? '' : 'height: 47vh;'">
          <div class="form-input">
            <img src="../assets/jump/icon-username.png" />
            <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
          </div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/jump/icon-phone.png" />
            <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
          </div>
          <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
            <img src="../assets/jump/icon-password.png" />
            <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
          </div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/jump/icon-email.png" />
            <input v-model="form.email" autocomplete="off" placeholder="Email" />
          </div>
          <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0; position: relative;">
            <input style="text-indent: 10px;" v-model="form.verificationCode" maxlength="4" autocomplete="off" />
            <div class="codeImg">
              <span @click="getVerify" v-if="codeImg" class="validateCode">
                <img class="img" :src="codeImg" alt="code" />
              </span>
            </div>
          </div>
          <a v-if="!isRegisterAction" class="error" href="https://www.8day.com">Quên Mật Khẩu?</a>
          <v-captcha ref="vcaptcha2" :dialogVisible="dialogVisible" :showCheck="showCheck" :vstyle="{
              top: '2vh',
              position: 'relative'
            }" :nativeButton="{
              width: '43.7333vw',
              height: '7.6461vh'
            }" @cb="handleConfirm">
            <div v-show="isRegisterAction" class="submitBtn" @click="submitAction(1)">
              ĐĂNG KÝ
            </div>
          </v-captcha>
          <div v-show="!isRegisterAction" class="submitBtn" @click="submitAction(2)">
            ĐĂNG NHẬP
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import md5 from "js-md5";
import {
  FORM_VALID_MESSAGE,
  DOMAIN_AGENT_CODE,
  CONTRACTS
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode } from "../utils/request";
import { encodePlatformUrl, validForm, isMobile } from "../utils/tools";
import { captcha } from "@/mixins/captcha";

export default {
  name: "Jump",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    return {
      codeImg: '',
      isMobile: isMobile(),
      loading: false,
      isRegisterAction: true,
      dialogVisible: false,
      dialogBgi: require("../assets/jump/bgi-dialog.png"),
      closeBtnImg: require("../assets/jump/icon-close.png"),
      contacts: CONTRACTS,
      swiperOptions: {
        speed: 1000,
        loop: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        effect: "slide",
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn"
        }
      },
      form: {
        by: 1,
        username: "",
        verificationCode: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      errorMsg: {
        title: "",
        content: ""
      }
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.userName,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = DOMAIN_AGENT_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.username = this.form.userName;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        this.loading = false;
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      params.verificationCode = this.form.verificationCode;
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
@media only screen and (min-width: 1420px) and (max-width: 1680px) {
  .container .content .submitBtn,
  .container .content .tags .tag {
    font-size: 24px !important;
  }
}

.container {
  ::-ms-input-placeholder {
    font-size: 24px;
    color: #ffffff;
  }

  ::-webkit-input-placeholder {
    font-size: 24px;
    color: #ffffff;
  }

  .content {
    width: 100vw;
    height: 100vh;
    background-image: url("../assets/jump/bgi-pc.jpg");
    background-size: 100% 100%;
    margin: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10%;

    img.logo {
      width: 164px;
      position: fixed;
      top: 20px;
      left: calc(50% - 82px);
    }

    .form-content {
      width: 33.3333%;
      height: 673px;
      box-sizing: border-box;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      align-items: center;

      img.title {
        width: 50%;
      }

      .form {
        width: 100%;

        .tags {
          width: 100%;
          height: 70px;
          position: relative;
          top: 15%;
          z-index: 99;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-family: "Montserrat";
          font-size: 20px;
          color: #ffffff;

          .tag {
            width: 55%;
            height: 100%;
            line-height: 3;
            text-indent: 3em;
            cursor: pointer;
            position: relative;

            &:nth-child(1) {
              background-image: url("../assets/jump/bgi-tag-left.png");
              background-size: 100% 100%;

              &.active {
                background-image: url("../assets/jump/bgi-tag-left-active.png");
              }
            }

            &:nth-child(2) {
              text-indent: 5em;
              background-image: url("../assets/jump/bgi-tag-right.png");
              background-size: 100% 100%;

              &.active {
                background-image: url("../assets/jump/bgi-tag-right-active.png");
              }
            }
          }
        }

        .inputs {
          width: 100%;
          height: 522px;
          background-image: url("../assets/jump/bgi-form.png");
          background-size: 100% 100%;
          display: flex;
          flex-flow: column;
          justify-content: flex-start;
          align-items: center;
          box-sizing: border-box;
          padding-top: 120px;
          position: relative;
        }

        .form-input {
          width: 60%;
          height: 50px;
          position: relative;
          margin-bottom: 10px;

          .codeImg {
            cursor: pointer;
            width: 150px;
            height: 100%;
            position: absolute;
            right: -6px;
            top: 1px;
            .img {
              width: 150px;
              height: 100%;
              border-radius: 15px;
              position: unset;
            }
          }

          img {
            width: 30px;
            height: 30px;
            position: absolute;
            top: calc(50% - 15px);
            left: 20px;
          }

          input {
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 10px;
            border: none;
            outline: none;
            text-indent: 60px;
            font-size: 24px;
            color: #ffffff;
          }
        }

        a.error {
          display: block;
          margin: 20px;
          color: #ffffff;
          font-size: 20px;
          text-decoration: none;
        }

        .submitBtn {
          width: 250px;
          height: 70px;
          background-image: url("../assets/jump/bgi-btn.png");
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Montserrat-Black;
          font-size: 23px;
          color: #ffffff;
          cursor: pointer;
          position: absolute;
          bottom: 30px;
        }
      }
    }

    .swiper-content {
      width: 635px;
      height: 77.8%;
      background-image: url("../assets/jump/bgi-swiper.png");
      background-size: 100% 100%;
      position: relative;
      display: flex;
      align-items: flex-end;

      .swiper-container {
        width: 85%;
        height: 70%;
        bottom: 54px;
        left: -4px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .next-btn {
        right: -80px;
        width: 67px;
        height: 67px;
        background-image: url("../assets/jump/swiper-right.png");
      }

      .prev-btn {
        left: -80px;
        width: 67px;
        height: 67px;
        background-image: url("../assets/jump/swiper-left.png");
      }

      .nav-btn {
        position: absolute;
        top: calc(50% - 33.5px);
      }
    }

    /deep/ .mask-layer .modal .close-img {
      top: -32px;
      right: -32px;
      position: absolute;
      cursor: pointer;
    }
  }
}

.root {
  width: 100vw;
  padding-bottom: 20vh;
  background-image: url("../assets/jump/bgi-h5.jpg");
  background-size: 100% 100%;
  margin: 0;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: center;
  color: #ffffff;
  overflow: hidden;
  padding-top: 2vw;

  ::-webkit-scrollbar {
    display: none;
  }

  ::-ms-input-placeholder {
    font-size: 1.2em;
  }

  ::-webkit-input-placeholder {
    font-size: 1.2em;
  }

  img.logo {
    height: 14.2428vh;
  }

  img.title {
    width: 80%;
  }

  .form-content {
    width: 90%;
    display: flex;
    flex-flow: column;
    align-items: center;

    .tags {
      width: 115%;
      height: 8vh;
      position: relative;
      font-family: "Montserrat-Black";
      font-size: 1em;
      color: #ffffff;
      z-index: 1;

      .tag {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;

        &:nth-child(1) {
          left: 5%;
          text-indent: -3em;
          background-image: url("../assets/jump/bgi-tag-left.png");
          background-size: 100% 100%;

          &.active {
            background-image: url("../assets/jump/bgi-tag-left-active.png");
          }
        }

        &:nth-child(2) {
          right: 5%;
          text-indent: 3em;
          background-image: url("../assets/jump/bgi-tag-right.png");
          background-size: 100% 100%;

          &.active {
            background-image: url("../assets/jump/bgi-tag-right-active.png");
          }
        }
      }
    }

    .inputs {
      width: 100%;
      height: 64vh;
      background-image: url("../assets/jump/bgi-form-h5.png");
      background-size: 100% 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      position: relative;
      box-sizing: border-box;
      padding-top: 20%;
      top: -8.4vh;
      z-index: 0;

      .form-input {
        width: 70%;
        height: 7.871vh;
        position: relative;
        margin-top: 2vw;

        .codeImg {
          cursor: pointer;
          width: 150px;
          height: 100%;
          position: absolute;
          right: -6px;
          top: 1px;
          .img {
            width: 150px;
            height: 100%;
            border-radius: 15px;
            position: unset;
          }
        }

        img {
          width: 6vw;
          height: 6vw;
          position: absolute;
          top: calc(50% - 3vw);
          left: 5vw;
        }

        input {
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
          border: none;
          outline: none;
          text-indent: 15vw;
          font-size: 0.8em;
          color: #ffffff;
        }
      }

      a.error {
        display: block;
        margin: 20px;
        color: #ffffff;
        font-size: 20px;
        text-decoration: none;
      }

      .submitBtn {
        width: 43.7333vw;
        height: 7.6461vh;
        background-image: url("../assets/jump/bgi-btn.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Montserrat-Black;
        font-size: 1.2em;
        color: #ffffff;
        position: absolute;
        bottom: 2vh;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Jump.vue